import React, {useState} from 'react';
import * as Common from '../common/app_common.js';
import {Title} from '../common/component_common.js';
import '../common/css/control_alert.css'
import * as EndPoint from './control_alert/end_point.js'
import * as SiteEndpoint from './control_alert/site_end_point.js'
import * as Rules from './control_alert/rules.js'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {DecideWindow} from '../common/modal_common.js';

const AlertTab = ({tabIndex, setTabIndex}) => {

    // useEffect(() => {
    //     //
    // }, []);

    // useInterval(() =>
    // {
    //     //
    // }, 10000 );

    return (
        <Tabs
            defaultActiveKey="EndPoint"
            transition={true}
            activeKey={tabIndex}
            onSelect={(k) => setTabIndex(k)}
            className="mt-3" >
            <Tab tabClassName={`${tabIndex==="EndPoint"?"":"none-activate"}`} eventKey="EndPoint" title="EndPoint"/>
            <Tab tabClassName={`${tabIndex==="SiteEndpoint"?"":"none-activate"}`} eventKey="SiteEndpoint" title="Site Endpoint"/>
            <Tab tabClassName={`${tabIndex==="Rules"?"":"none-activate"}`} eventKey="Rules" title="Rules"/>
        </Tabs>
    )    
}

const PageControlAlert = () => {
    const [tabIndex, setTabIndex] = useState('EndPoint');
    const [pendingTab, setPendingTab] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [existUpdate, setExistUpdate] = useState(false); // SiteEndpoint에서 변경사항 여부를 받아올 예정

    // 탭 이동 핸들러
    const handleTabChange = (nextTab) => {
        if (tabIndex === nextTab) return;
        if (existUpdate) {
            setPendingTab(nextTab);
            setModalVisible(true);
        } else {
            setTabIndex(nextTab);
            setExistUpdate(false);
        }
    };

    // 모달 OK 클릭 시
    const handleModalOk = (is) => {
        setModalVisible(false);
        if (is) {
            setTabIndex(pendingTab);
            setPendingTab(null);
            setExistUpdate(false);
        }
    };

    return (
        <>
            <Title title='Alert'></Title>
            <AlertTab tabIndex={tabIndex} setTabIndex={handleTabChange}></AlertTab>
            {tabIndex==='EndPoint'&&<EndPoint.View existUpdate={existUpdate} setExistUpdate={setExistUpdate}></EndPoint.View>}
            {tabIndex==='SiteEndpoint'&&<SiteEndpoint.View existUpdate={existUpdate} setExistUpdate={setExistUpdate}></SiteEndpoint.View>}
            {tabIndex==='Rules'&&<Rules.View></Rules.View>}
            {modalVisible && (
                <DecideWindow
                    show={modalVisible}
                    handleClose={() => setModalVisible(false)}
                    body={<div className='text-center'><p>There are unsaved changes. Are you sure you want to leave this tab?</p></div>}
                    okButtonTxt={'OK'}
                    result={handleModalOk}
                />
            )}
        </>
    )
}

export default PageControlAlert;